import { render, staticRenderFns } from "./mentoring.vue?vue&type=template&id=4f7d86e3&scoped=true"
import script from "./mentoring.vue?vue&type=script&lang=js"
export * from "./mentoring.vue?vue&type=script&lang=js"
import style0 from "./mentoring.vue?vue&type=style&index=0&id=4f7d86e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7d86e3",
  null
  
)

export default component.exports